
export const filterAndSortViewings = (unit: any, task : any,  sortType :Record<string, any>): boolean => {

    const sortByViewingsGroups = sortType.byViewingGroups as string[]
    const sortByTypeUnit = sortType.sortByTypeUnit
    const sortByUnitID = sortType.unitID
    const statuses = task?.attributes?.Statuses as any[]; 
 
   
    const statusMatch = sortByViewingsGroups?.includes('all') || sortByViewingsGroups?.includes(statuses[0])
    const idMatch = !sortByUnitID || Number(sortByUnitID) === Number(unit?.id);
      

    if (!statusMatch) return false;
    if (!idMatch) return false;
      
    if (sortByTypeUnit === 'all') return true;
    if (sortByTypeUnit === 'sale') return unit?.attributes?.Marketing?.Use === 'For sale';
    if (sortByTypeUnit === 'rent') return unit?.attributes?.Marketing?.Use === 'For rent';
 
    return false;
};